var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top", "label-width": "90px" } },
        [
          _c(
            "el-form-item",
            {
              staticClass: "user-type",
              attrs: { label: "⚙ 选择审批对象", prop: "text" },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.nodeProps.assignedType,
                    callback: function ($$v) {
                      _vm.$set(_vm.nodeProps, "assignedType", $$v)
                    },
                    expression: "nodeProps.assignedType",
                  },
                },
                _vm._l(_vm.approvalTypes, function (t) {
                  return _c(
                    "el-radio",
                    { key: t.type, attrs: { label: t.type } },
                    [_vm._v(_vm._s(t.name))]
                  )
                }),
                1
              ),
              _vm.nodeProps.assignedType === "ASSIGN_USER"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            icon: "el-icon-plus",
                            type: "primary",
                            round: "",
                          },
                          on: { click: _vm.selectUser },
                        },
                        [_vm._v("选择人员")]
                      ),
                      _c("org-items", {
                        model: {
                          value: _vm.nodeProps.assignedUser,
                          callback: function ($$v) {
                            _vm.$set(_vm.nodeProps, "assignedUser", $$v)
                          },
                          expression: "nodeProps.assignedUser",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "SELF_SELECT"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          model: {
                            value: _vm.nodeProps.selfSelect.multiple,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nodeProps.selfSelect,
                                "multiple",
                                $$v
                              )
                            },
                            expression: "nodeProps.selfSelect.multiple",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: false } }, [
                            _vm._v("自选一个人"),
                          ]),
                          _c("el-radio-button", { attrs: { label: true } }, [
                            _vm._v("自选多个人"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "LEADER_TOP"
                ? _c(
                    "div",
                    [
                      _c("el-divider"),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "approve-end",
                          attrs: { label: "审批终点", prop: "text" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.nodeProps.leaderTop.endCondition,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.nodeProps.leaderTop,
                                    "endCondition",
                                    $$v
                                  )
                                },
                                expression: "nodeProps.leaderTop.endCondition",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "TOP" } }, [
                                _vm._v("直到最上层主管"),
                              ]),
                              _c("el-radio", { attrs: { label: "LEAVE" } }, [
                                _vm._v("不超过发起人的"),
                              ]),
                            ],
                            1
                          ),
                          _vm.nodeProps.leaderTop.endCondition === "LEAVE"
                            ? _c(
                                "div",
                                { staticClass: "approve-end-leave" },
                                [
                                  _c("span", [_vm._v("第 ")]),
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 1,
                                      max: 20,
                                      step: 1,
                                      size: "mini",
                                    },
                                    model: {
                                      value: _vm.nodeProps.leaderTop.level,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.nodeProps.leaderTop,
                                          "level",
                                          $$v
                                        )
                                      },
                                      expression: "nodeProps.leaderTop.level",
                                    },
                                  }),
                                  _c("span", [_vm._v(" 级主管")]),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "LEADER"
                ? _c(
                    "div",
                    [
                      _c("el-divider"),
                      _c(
                        "el-form-item",
                        { attrs: { label: "指定主管", prop: "text" } },
                        [
                          _c("span", [_vm._v("发起人的第 ")]),
                          _c("el-input-number", {
                            attrs: { min: 1, max: 20, step: 1, size: "mini" },
                            model: {
                              value: _vm.nodeProps.leader.level,
                              callback: function ($$v) {
                                _vm.$set(_vm.nodeProps.leader, "level", $$v)
                              },
                              expression: "nodeProps.leader.level",
                            },
                          }),
                          _c("span", [_vm._v(" 级主管")]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#409EFF",
                                "font-size": "small",
                              },
                            },
                            [_vm._v("👉 直接主管为 第 1 级主管")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "ROLE"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            icon: "el-icon-plus",
                            type: "primary",
                            round: "",
                          },
                          on: { click: _vm.selectRole },
                        },
                        [_vm._v("选择系统角色")]
                      ),
                      _c("org-items", {
                        model: {
                          value: _vm.nodeProps.role,
                          callback: function ($$v) {
                            _vm.$set(_vm.nodeProps, "role", $$v)
                          },
                          expression: "nodeProps.role",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.nodeProps.assignedType === "FORM_USER"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "approve-end",
                          attrs: { label: "选择表单联系人项", prop: "text" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "80%" },
                              attrs: {
                                size: "small",
                                placeholder: "请选择包含联系人的表单项",
                              },
                              model: {
                                value: _vm.nodeProps.formUser,
                                callback: function ($$v) {
                                  _vm.$set(_vm.nodeProps, "formUser", $$v)
                                },
                                expression: "nodeProps.formUser",
                              },
                            },
                            _vm._l(_vm.forms, function (op) {
                              return _c("el-option", {
                                key: op.id,
                                attrs: { label: op.title, value: op.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _c("span", { staticClass: "item-desc" }, [
                      _vm._v("发起人自己作为审批人进行审批"),
                    ]),
                  ]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-form-item",
            {
              staticClass: "line-mode",
              attrs: { label: "⚙子流程表单", prop: "text" },
            },
            [
              _c("el-cascader", {
                staticStyle: { width: "80%" },
                attrs: {
                  size: "small",
                  placeholder: "请选择子流程表单",
                  options: _vm.fromGroup,
                  props: { expandTrigger: "hover" },
                  "show-all-levels": false,
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.nodeProps.subprocessId,
                  callback: function ($$v) {
                    _vm.$set(_vm.nodeProps, "subprocessId", $$v)
                  },
                  expression: "nodeProps.subprocessId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: {
          title: _vm.pickerTitle,
          multiple: "",
          type: _vm.orgPickerType,
          selected: _vm.orgPickerSelected,
        },
        on: { ok: _vm.selected },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }